<template>
  <div>
    <file-upload
        input-id="file3"
        class="has-text-centered upload"
        post-action="/upload/post"
        extensions="jpg,jpeg,png"
        accept="image/png,image/jpeg"
        :drop="true"
        v-model="files"
        ref="file3"
        :size="1024 * 1024 *10"
        @input-filter="inputFilter3"


    > w er wer we r wer we r wer we r wer we rw er we rw er wer wer
    </file-upload>
  </div>
</template>

<script>
import VueUploadComponent from 'vue-upload-component';

export default {
  name: 'FileComponent',
  props: {
    msg: String
  },
  components: {
    'file-upload': VueUploadComponent
  },
  data() {
    return {

      files: [],
    };
  },
  methods: {
    inputFilter3(newFile, oldFile, prevent) {
      console.log(newFile);
      if (newFile && !oldFile) {

        if (!newFile.name.match((/.png|.jpg|.gif$/))) {
          alert("El archivo tiene que ser un png o un jpg");
          return prevent();
        }
      }

      if (newFile.size > 1024 * 1024 * 10) {
        alert("El archivo tiene que ser menos de 10mb" + newFile.size);
        return prevent();
      }

      if (newFile && newFile.error === "" && newFile.file && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = '';
        let URL = (window.URL || window.webkitURL);
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = '';
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob;
        }
      }
    }
  }
};
</script>


<style>
.upload {
  background: red;
}
</style>